import { getCountry, getLanguage } from '@dazn/lp-web/src/utils/dazn/Region';
import localisePrice from '@dazn/lp-web/src/utils/localisePrice';

const getHomeCountryPrice = (price?: number, currency?: string) => {
    return price && currency
        ? localisePrice(
            price,
            currency,
            `${getLanguage()}-${getCountry()}`
        )
        : undefined;
};
export { getHomeCountryPrice };
